export const costs = [
  'Noches en vela buscando cómo traducir conceptos de gestión ambiental complejos a un lenguaje que tus alumnos puedan entender.',
  'Clases improvisadas porque no encontraste un material claro y listo para usar a tiempo.',
  'Alumnos desconectados que sienten que la gestión ambiental no tiene nada que ver con ellos ni con su realidad cotidiana.',
  'Silencios incómodos cuando un alumno pregunta qué es la economía circular o cómo se gestiona el agua y no tienes una respuesta clara a mano.',
  'Fines de semana perdidos armando planificaciones, proyectos ambientales y evaluaciones desde cero una y otra vez.',
  'Incertidumbre sobre cómo enseñar biodiversidad, sistemas de gestión ambiental o riesgos ambientales sin los recursos adecuados.',
];
